export type ProjectClassData = {
  id: number;
  name: string;
  projectCode: string;
  code: number;
  minStudents?: number;
  maxStudents?: number;
  startStudyingAt: string;
};

export type ProjectClass = {
  id: number;
  name: string;
  projectCode: string;
  code: number;
  minStudents?: number;
  maxStudents?: number;
  enlargementDeadline?: string;
  reductionDeadline?: string;
};

const defaultProjectClass: ProjectClass = {
  id: 0,
  name: '',
  projectCode: '',
  code: 0,
};

export const projectClassFactory = (projectClassAttrs?: {
  [P in keyof ProjectClass]?: ProjectClass[P];
}): ProjectClass => ({ ...defaultProjectClass, ...projectClassAttrs });
